import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { isEmail, isPasswordValid, isRequired } from 'forms/utils/validators';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { registerUser } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';

const fields: FieldsDefinitions = [
  {
    name: 'newEmail',
    label: registerUser.email,
    bindings: 'TextField',
    value: '',
    validators: [isRequired, isEmail],
  },
  {
    name: 'password',
    label: registerUser.password,
    bindings: 'TextField',
    type: 'password',
    value: '',
    validators: [isRequired, isPasswordValid],
  },
];

export function registerForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
